'use strict';

var util = angular.module('gymsystem.util');

util.directive('schedule', ['$rootScope', function($rootScope) {
    return {
        restrict: 'E',
        template: '<div ng-include="\'views/workschedule.html\'"></div>',
        scope: {
            settings: '=',
            control: '=?'
        },
        link: function($scope, element) {
            $scope.hasPermission = $rootScope.hasPermission;
            $scope.getCustomerForField = $rootScope.getCustomerForField;
            $scope.getMultiFieldBuilderForField = $rootScope.getMultiFieldBuilderForField;
            $scope.getFieldBuilderForField = $rootScope.getFieldBuilderForField;
            $scope.getCustomersForField = $rootScope.getCustomersForField;
            $scope.getAccountsForField = $rootScope.getAccountsForField;
            $scope.getCashierForField = $rootScope.getCashierForField;
            $scope.getPaymentMethodForField = $rootScope.getPaymentMethodForField;
            $scope.getItemListText = $rootScope.getItemListText;
            $scope.getProductsForField = $rootScope.getProductsForField;

            $scope.tabSettings = $scope.settings.tabs;
            $scope.scheduleTitle = 'My schedule';
            var width = element.parent().parent().width();
            $scope.smallCalendar = width <= 768;

            if ($scope.smallCalendar) {
                element.addClass('small-calendar');
            }

            $scope.isSmallCalendar = function() {
                return $scope.smallCalendar;
            };

            if ($scope.control) {
                $scope.control.sizeChanged = function(width) {
                    $scope.smallCalendar = width <= 768;
                    if ($scope.smallCalendar) {
                        element.addClass('small-calendar');
                    } else {
                        element.removeClass('small-calendar');
                    }
                };
            }
        }
    };
}]);
